export const BRAND_SEARCH_PREFIX = 'Brand:';
